<template>
  <div class="robocoin-home">
    <div class="home-grid"></div>

    <header class="site-nav">
      <button class="brand-lockup" type="button" @click="goHome">
        <img :src="heroImage" alt="RoboCoin" />
        <span>
          <strong>RoboCoin</strong>
          <em>DeRAS Network</em>
        </span>
      </button>

      <nav class="primary-nav" aria-label="主要导航">
        <button v-if="currentUser" class="nav-action" type="button" aria-label="任务市场" @click="goToTaskMarket">
          <Shop class="nav-icon" aria-hidden="true" />
          <span class="nav-tooltip">任务市场</span>
        </button>
        <button v-if="currentUser" class="nav-action" type="button" aria-label="进行中任务" @click="goToActiveOrders">
          <Clock class="nav-icon" aria-hidden="true" />
          <span class="nav-tooltip">进行中任务</span>
        </button>
        <button v-if="currentUser" class="nav-action" type="button" aria-label="派单邀请" @click="goToDispatchInvitations">
          <Bell class="nav-icon" aria-hidden="true" />
          <span class="nav-tooltip">派单邀请</span>
        </button>
        <button class="nav-action" type="button" aria-label="开放接口" @click="downloadApiDoc">
          <Connection class="nav-icon" aria-hidden="true" />
          <span class="nav-tooltip">开放接口</span>
        </button>
        <button class="nav-action" type="button" aria-label="任务大屏" @click="openBigscreen">
          <DataAnalysis class="nav-icon" aria-hidden="true" />
          <span class="nav-tooltip">任务大屏</span>
        </button>
      </nav>

      <div class="account-actions">
        <template v-if="currentUser">
          <button class="nav-action" type="button" aria-label="复制 API Token" @click="copyToken">
            <CopyDocument class="nav-icon" aria-hidden="true" />
            <span class="nav-tooltip">复制 Token</span>
          </button>
          <button class="nav-action" type="button" aria-label="个人中心" @click="goToProfile">
            <User class="nav-icon" aria-hidden="true" />
            <span class="nav-tooltip">个人中心</span>
          </button>
          <button class="nav-action logout-action" type="button" aria-label="退出登录" @click="handleLogout">
            <SwitchButton class="nav-icon" aria-hidden="true" />
            <span class="nav-tooltip">退出登录</span>
          </button>
        </template>
        <button v-else class="login-btn" type="button" @click="goToLogin">登录 / 注册</button>
      </div>
    </header>

    <main class="hero-shell">
      <section class="hero-copy">
        <h1>RoboCoin</h1>

        <div class="hero-actions">
          <button class="entry-card primary-entry" type="button" @click="goToTask">
            <span>01</span>
            <strong>发布任务</strong>
          </button>
          <button class="entry-card" type="button" @click="goToRegister">
            <span>02</span>
            <strong>注册机器人</strong>
          </button>
        </div>

      </section>

      <section class="hero-visual">
        <div class="visual-frame">
          <img
            v-for="(image, index) in publishImages"
            :key="image"
            :src="image"
            :class="['visual-slide', { active: publishSlideIndex === index }]"
            alt="RoboCoin service scenario"
          />
          <div class="visual-shade"></div>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import heroImage from '../images/RoboCoin.png'
import publishImageOne from '../images/faburwu2.png'
import publishImageTwo from '../images/faburwu3.png'
import publishImageThree from '../images/faburwu.png'
import {
  Bell,
  Clock,
  Connection,
  CopyDocument,
  DataAnalysis,
  Shop,
  SwitchButton,
  User
} from '@element-plus/icons-vue'
import { getAuthRole, getAuthUser, getToken, isLoggedIn, logout } from '../utils/auth'

export default {
  name: 'RoboCoinLanding',
  components: {
    Bell,
    Clock,
    Connection,
    CopyDocument,
    DataAnalysis,
    Shop,
    SwitchButton,
    User
  },
  data() {
    return {
      heroImage,
      publishImages: [publishImageOne, publishImageTwo, publishImageThree],
      publishSlideIndex: 0,
      publishSlideTimer: null,
      currentUser: getAuthUser(),
      currentRole: getAuthRole(),
      currentToken: getToken()
    }
  },
  methods: {
    goHome() {
      this.$router.push({ name: 'home' })
    },
    startPublishCarousel() {
      if (this.publishSlideTimer) window.clearInterval(this.publishSlideTimer)
      this.publishSlideTimer = window.setInterval(() => {
        this.publishSlideIndex = (this.publishSlideIndex + 1) % this.publishImages.length
      }, 6000)
    },
    downloadApiDoc() {
      this.$router.push({ name: 'openApiDoc' })
    },
    contactSupport() {
      window.open('mailto:support@robocoin.global?subject=RoboCoin%20Support', '_blank')
    },
    openBigscreen() {
      window.open('/bigscreen/', '_blank')
    },
    async copyToken() {
      if (!this.currentToken) {
        this.$message.warning('当前没有可用 Token，请先登录')
        return
      }
      try {
        await navigator.clipboard.writeText(this.currentToken)
        this.$message.success('API Token 已复制')
      } catch (error) {
        this.$message.error('复制失败，请手动复制 Token')
      }
    },
    goToLogin() {
      this.$router.push({ name: 'login' })
    },
    goToTask() {
      this.goProtected('mall')
    },
    goToRegister() {
      this.goProtected('user')
    },
    goToTaskMarket() {
      this.goProtected('taskMarket')
    },
    goToActiveOrders() {
      this.goProtected('activeOrders')
    },
    goToDispatchInvitations() {
      this.goProtected('dispatchInvitations')
    },
    goToProfile() {
      this.goProtected('profile')
    },
    goProtected(name) {
      if (isLoggedIn()) {
        if (this.currentRole === 'admin') {
          this.$message.warning('当前是管理员会话，请退出后使用普通用户账号')
          return
        }
        this.$router.push({ name })
        return
      }
      this.$router.push({ name: 'login', query: { redirect: name } })
    },
    handleLogout() {
      logout()
      this.currentUser = null
      this.currentRole = 'user'
      this.currentToken = ''
      this.$message.success('已退出登录')
    },
    refreshAuth() {
      this.currentUser = getAuthUser()
      this.currentRole = getAuthRole()
      this.currentToken = getToken()
    }
  },
  mounted() {
    this.startPublishCarousel()
  },
  beforeUnmount() {
    if (this.publishSlideTimer) window.clearInterval(this.publishSlideTimer)
  },
  watch: {
    '$route.fullPath'() {
      this.refreshAuth()
    }
  }
}
</script>

<style scoped>
.robocoin-home {
  position: relative;
  min-height: 100vh;
  overflow: hidden;
  padding: 24px 32px 34px;
  color: #f7fbff;
  background:
    radial-gradient(circle at 18% 12%, rgba(133, 223, 255, 0.12), transparent 26%),
    radial-gradient(circle at 86% 16%, rgba(247, 184, 95, 0.11), transparent 24%),
    linear-gradient(135deg, #05080f 0%, #071421 54%, #03060b 100%);
}

.home-grid {
  position: absolute;
  inset: 0;
  pointer-events: none;
  background-image:
    linear-gradient(rgba(142, 231, 255, 0.045) 1px, transparent 1px),
    linear-gradient(90deg, rgba(142, 231, 255, 0.045) 1px, transparent 1px);
  background-size: 58px 58px;
  mask-image: linear-gradient(180deg, rgba(0, 0, 0, 0.86), rgba(0, 0, 0, 0.3));
}

.site-nav,
.hero-shell {
  position: relative;
  z-index: 1;
}

.site-nav {
  z-index: 20;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: min(1620px, 100%);
  min-height: 64px;
  gap: 16px;
  margin: 0 auto;
  padding: 8px 10px;
  border: 1px solid rgba(142, 231, 255, 0.12);
  border-radius: 8px;
  background: rgba(5, 13, 22, 0.54);
  box-shadow: 0 18px 54px rgba(0, 0, 0, 0.22);
  backdrop-filter: blur(22px) saturate(135%);
}

.brand-lockup,
.primary-nav,
.account-actions {
  display: flex;
  align-items: center;
  gap: 4px;
}

.brand-lockup,
.user-chip {
  border: 1px solid rgba(142, 231, 255, 0.16);
  border-radius: 8px;
  color: #f7fbff;
  background: rgba(255, 255, 255, 0.045);
  backdrop-filter: blur(14px);
}

.brand-lockup {
  min-width: 188px;
  padding: 5px 10px 5px 5px;
  cursor: pointer;
  transition: border-color 0.2s ease, background 0.2s ease;
}

.brand-lockup:hover,
.brand-lockup:focus-visible {
  border-color: rgba(142, 231, 255, 0.34);
  background: rgba(142, 231, 255, 0.08);
  outline: none;
}

.brand-lockup img {
  width: 36px;
  height: 36px;
  object-fit: contain;
  border-radius: 6px;
  background: #fff;
}

.brand-lockup span,
.brand-lockup strong,
.brand-lockup em {
  display: block;
  text-align: left;
}

.brand-lockup strong {
  font-size: 15px;
}

.brand-lockup em {
  margin-top: 2px;
  color: rgba(226, 237, 248, 0.56);
  font-size: 11px;
  font-style: normal;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.primary-nav button,
.account-actions button,
.user-chip {
  min-height: 40px;
  font-weight: 700;
}

.primary-nav,
.account-actions {
  padding: 4px;
  border: 1px solid rgba(142, 231, 255, 0.1);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.025);
}

.primary-nav {
  position: static;
  margin-left: 16px;
  transform: none;
}

.account-actions {
  margin-left: auto;
}

.nav-action {
  position: relative;
  display: grid;
  place-items: center;
  width: 42px;
  height: 42px;
  min-height: 42px !important;
  padding: 0 !important;
  border: 1px solid transparent !important;
  border-radius: 7px !important;
  color: rgba(226, 237, 248, 0.64) !important;
  background: transparent !important;
  box-shadow: none !important;
  cursor: pointer;
  transition:
    color 0.2s ease,
    border-color 0.2s ease,
    background 0.2s ease,
    box-shadow 0.2s ease,
    transform 0.2s ease;
}

.nav-action:hover,
.nav-action:focus-visible {
  z-index: 4;
  border-color: rgba(142, 231, 255, 0.28) !important;
  color: #f7fbff !important;
  background: rgba(142, 231, 255, 0.1) !important;
  box-shadow:
    0 10px 28px rgba(0, 0, 0, 0.28),
    0 0 0 1px rgba(142, 231, 255, 0.06) inset !important;
  outline: none;
  transform: translateY(-1px);
}

.nav-icon {
  width: 20px;
  height: 20px;
}

.nav-tooltip {
  position: absolute;
  top: calc(100% + 12px);
  left: 50%;
  z-index: 10;
  padding: 8px 10px;
  border: 1px solid rgba(142, 231, 255, 0.2);
  border-radius: 7px;
  color: rgba(247, 251, 255, 0.92);
  background: rgba(5, 13, 22, 0.88);
  box-shadow: 0 18px 42px rgba(0, 0, 0, 0.34);
  backdrop-filter: blur(18px) saturate(130%);
  font-size: 12px;
  font-weight: 700;
  line-height: 1;
  white-space: nowrap;
  pointer-events: none;
  opacity: 0;
  transform: translate(-50%, -5px);
  transition: opacity 0.18s ease, transform 0.18s ease;
}

.nav-tooltip::before {
  position: absolute;
  bottom: 100%;
  left: 50%;
  width: 7px;
  height: 7px;
  border-top: 1px solid rgba(142, 231, 255, 0.2);
  border-left: 1px solid rgba(142, 231, 255, 0.2);
  background: rgba(5, 13, 22, 0.88);
  content: '';
  transform: translate(-50%, 4px) rotate(45deg);
}

.nav-action:hover .nav-tooltip,
.nav-action:focus-visible .nav-tooltip {
  opacity: 1;
  transform: translate(-50%, 0);
}

.logout-action:hover,
.logout-action:focus-visible {
  border-color: rgba(255, 137, 137, 0.28) !important;
  color: #ffb6b6 !important;
  background: rgba(255, 107, 107, 0.09) !important;
}

.login-btn,
.primary-action {
  border-color: rgba(116, 242, 191, 0.34) !important;
  color: #041019 !important;
  background: linear-gradient(135deg, #8ee7ff, #74f2bf) !important;
}

.hero-shell {
  min-height: calc(100vh - 92px);
  display: grid;
  grid-template-columns: minmax(360px, 0.8fr) minmax(500px, 1.2fr);
  gap: 34px;
  align-items: center;
  max-width: 1620px;
  margin: 0 auto;
}

.hero-copy {
  display: grid;
  align-content: center;
  justify-items: start;
}

.hero-logo {
  width: 112px;
  height: 112px;
  object-fit: contain;
  padding: 12px;
  border: 1px solid rgba(142, 231, 255, 0.16);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.9);
  box-shadow: 0 24px 70px rgba(0, 0, 0, 0.28);
}

.hero-copy h1 {
  max-width: 780px;
  margin: 24px 0 0;
  font-size: clamp(56px, 8vw, 126px);
  line-height: 0.95;
  letter-spacing: 0;
}

.hero-actions {
  display: grid;
  width: min(520px, 100%);
  gap: 14px;
  margin-top: 34px;
}

.entry-card {
  display: grid;
  grid-template-columns: 54px minmax(0, 1fr);
  align-items: center;
  gap: 16px;
  min-height: 78px;
  padding: 0 20px;
  border-radius: 8px;
  border: 1px solid rgba(142, 231, 255, 0.18);
  color: #f7fbff;
  text-align: left;
  background: rgba(255, 255, 255, 0.055);
  font-weight: 900;
  cursor: pointer;
}

.entry-card span {
  display: grid;
  place-items: center;
  width: 44px;
  height: 44px;
  border-radius: 8px;
  color: #041019;
  background: linear-gradient(135deg, #8ee7ff, #74f2bf);
}

.entry-card strong {
  font-size: 22px;
}

.primary-entry {
  border-color: rgba(116, 242, 191, 0.34);
  background: rgba(116, 242, 191, 0.08);
}

.hero-visual {
  display: grid;
  gap: 14px;
}

.visual-frame {
  position: relative;
  min-height: 620px;
  overflow: hidden;
  border: 1px solid rgba(142, 231, 255, 0.16);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.04);
  box-shadow: 0 34px 90px rgba(0, 0, 0, 0.34);
}

.visual-slide {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: 0;
  transform: scale(1.02);
  transition: opacity 0.7s ease, transform 0.7s ease;
}

.visual-slide.active {
  opacity: 1;
  transform: scale(1);
}

.visual-shade {
  position: absolute;
  inset: 0;
  background:
    linear-gradient(180deg, rgba(3, 8, 13, 0.04), rgba(3, 8, 13, 0.68)),
    linear-gradient(90deg, rgba(3, 8, 13, 0.38), transparent 52%);
}

@media (max-width: 1180px) {
  .site-nav {
    flex-wrap: wrap;
  }

  .primary-nav {
    position: static;
    order: 3;
    width: 100%;
    justify-content: center;
    transform: none;
  }

  .hero-shell {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 720px) {
  .robocoin-home {
    padding: 16px;
  }

  .site-nav {
    gap: 8px;
  }

  .brand-lockup {
    min-width: 0;
  }

  .brand-lockup em {
    display: none;
  }

  .nav-action {
    width: 40px;
    height: 40px;
    min-height: 40px !important;
  }

  .hero-copy h1 {
    font-size: 46px;
  }

  .visual-frame {
    min-height: 430px;
  }

}
</style>
